import createReducer from '../utils/createReducer';
import {
  APP_GIVE_CREDIT_CHECK_ACCESS,

  LOGIN_USER_REQUEST,
  LOGIN_USER_SUCCESS,
  LOGIN_USER_FAILURE,
  LOGIN_USER_UPDATE_SUCCESS,

  LOGIN_GIVE_HEADQUARTERS_ACCESS,
  LOGIN_GIVE_BRANCH_LEADER_SUPERVISOR_II_ACCESS,
  LOGIN_GIVE_BRANCH_LEADER_SUPERVISOR_ACCESS,
  LOGIN_GIVE_BRANCH_LEADER_ACCESS,
  LOGIN_GIVE_DEVELOPER_ACCESS,
  LOGIN_GIVE_DEVELOPER_SUPERVISOR,
  LOGIN_GIVE_DEVELOPER_SALES_MANAGER,
  LOGIN_GIVE_DEVELOPER_SALES_ADMIN,
  LOGIN_GIVE_DEVELOPER_STAFF,
  LOGIN_GIVE_EXTERNAL_AGENT_LEADER,
  LOGIN_GIVE_EXTERNAL_AGENT,
  LOGIN_GIVE_EXTERNAL_AGENCY_ADMIN,
  LOGIN_GIVE_DEVELOPER_SITEPLAN_ACCESS,
  LOGIN_GIVE_SUPER_ADMIN_ACCESS,
  LOGIN_GIVE_ADMIN_BASIC_ACCESS,
  LOGIN_GIVE_ADMIN_ACCESS,
  LOGIN_GIVE_MAIN_HEADQUARTERS_ACCESS,

  LOGIN_GIVE_EDIT_UNIT_PRICE_ACCESS,
  LOGIN_GIVE_EDIT_UNIT_DETAIL_ACCESS,

  LOGIN_FROM_ADFS,

  LOGOUT_USER_REQUEST,
  LOGOUT_USER_FAILURE,
  LOGOUT_USER_SUCCESS,
  LOGIN_GIVE_ADMIN_COMMUNITY_ACCESS,
} from '../constants/actions';

const initialState = {
  token: null,
  id: null,
  awsUsername: null,
  email: null,
  preferredName: null,
  affiliateID: null,
  affiliate: null,
  company: null,
  compayAppCredit: null,
  companyBranch: null,
  banker: null,
  groups: [],
  isAuthenticated: false,
  isAuthenticating: false,
  isHeadquarters: false,
  isBranchLeaderSupervisorII: false,
  isBranchLeaderSupervisor: false,
  isBranchLeader: false,
  isDeveloper: false,
  isDeveloperSupervisor: false,
  isDeveloperSalesManager: false,
  isDeveloperSalesAdmin: false,
  isDeveloperStaff: false,
  isExternalAgentLeader: false,
  isExternalAgent: false,
  isExternalAgencyAdmin: false,
  isSiteplan: false,
  isSuperAdmin: false,
  isAdminBasic: false,
  isAdminCommunity: false,
  isAdmin: false,
  isMainHeadquarters: false,
  creditCheckAccess: false,
  statusText: null,
  allowEditUnitPrice: false,
  allowEditUnitDetails: false,
  isADFS: false,
  adfsProvider: '',
  announcementAddBanker: null,
};

export default createReducer(initialState, {
  [LOGIN_USER_REQUEST]: state => (
    Object.assign({}, state, {
      isAuthenticating: true,
      isADFS: false,
      adfsProvider: '',
    })
  ),
  [LOGIN_USER_SUCCESS]: (state, payload) => (
    Object.assign({}, state, {
      announcementAddBanker: payload.announcementAddBanker,
      isAuthenticating: false,
      isAuthenticated: true,
      id: payload.id,
      awsUsername: payload.awsUsername,
      email: payload.email,
      preferredName: payload.preferredName,
      affiliateID: payload.affiliateID,
      language: payload.currentLanguageCode || payload.language,
      company: payload.affiliate ? payload.affiliate.company : {},
      companyApps: payload.affiliate && payload.affiliate.company ?
        [].concat(payload.affiliate.company.apps) : [],
      companyBranch: payload.affiliate ? payload.affiliate.companyBranch : {},
      groups: payload.groups ? [].concat(payload.groups) : [],
      statusText: 'You have been successfully logged in.',
    })
  ),
  [LOGIN_USER_FAILURE]: state => (
    Object.assign({}, state, {
      statusText: 'Authentication Error',
      isAuthenticated: false,
      isAuthenticating: false,
    })
  ),
  [LOGIN_USER_UPDATE_SUCCESS]: (state, payload) => (
    Object.assign({}, state, {
      email: payload.email,
      preferredName: payload.preferredName,
    })
  ),
  [LOGOUT_USER_REQUEST]: () => (
    Object.assign({}, initialState)
  ),
  [LOGOUT_USER_SUCCESS]: () => (
    Object.assign({}, initialState, {
      statusText: 'You have been successfully logged out.',
      isADFS: false,
      adfsProvider: '',
    })
  ),
  [LOGOUT_USER_FAILURE]: state => (
    Object.assign({}, state, {
      statusText: 'Logout error',
    })
  ),
  [LOGIN_GIVE_HEADQUARTERS_ACCESS]: state => (
    Object.assign({}, state, {
      isHeadquarters: true,
    })
  ),
  [LOGIN_GIVE_BRANCH_LEADER_SUPERVISOR_II_ACCESS]: state => (
    Object.assign({}, state, {
      isBranchLeaderSupervisorII: true,
    })
  ),
  [LOGIN_GIVE_BRANCH_LEADER_SUPERVISOR_ACCESS]: state => (
    Object.assign({}, state, {
      isBranchLeaderSupervisor: true,
    })
  ),
  [LOGIN_GIVE_BRANCH_LEADER_ACCESS]: state => (
    Object.assign({}, state, {
      isBranchLeader: true,
    })
  ),
  [LOGIN_GIVE_DEVELOPER_ACCESS]: state => (
    Object.assign({}, state, {
      isDeveloper: true,
    })
  ),
  [LOGIN_GIVE_DEVELOPER_SUPERVISOR]: state => (
    Object.assign({}, state, {
      isDeveloperSupervisor: true,
    })
  ),
  [LOGIN_GIVE_DEVELOPER_SALES_MANAGER]: state => (
    Object.assign({}, state, {
      isDeveloperSalesManager: true,
    })
  ),
  [LOGIN_GIVE_DEVELOPER_SALES_ADMIN]: state => (
    Object.assign({}, state, {
      isDeveloperSalesAdmin: true,
    })
  ),
  [LOGIN_GIVE_DEVELOPER_STAFF]: state => (
    Object.assign({}, state, {
      isDeveloperStaff: true,
    })
  ),
  [LOGIN_GIVE_EXTERNAL_AGENT_LEADER]: state => (
    Object.assign({}, state, {
      isExternalAgentLeader: true,
    })
  ),
  [LOGIN_GIVE_EXTERNAL_AGENT]: state => (
    Object.assign({}, state, {
      isExternalAgent: true,
    })
  ),
  [LOGIN_GIVE_EXTERNAL_AGENCY_ADMIN]: state => (
    Object.assign({}, state, {
      isExternalAgencyAdmin: true,
    })
  ),
  [LOGIN_GIVE_DEVELOPER_SITEPLAN_ACCESS]: state => (
    Object.assign({}, state, {
      isSiteplan: true,
    })
  ),
  [LOGIN_GIVE_MAIN_HEADQUARTERS_ACCESS]: state => (
    Object.assign({}, state, {
      isMainHeadquarters: true,
    })
  ),
  [LOGIN_GIVE_SUPER_ADMIN_ACCESS]: state => (
    Object.assign({}, state, {
      isSuperAdmin: true,
    })
  ),
  [LOGIN_GIVE_ADMIN_BASIC_ACCESS]: state => (
    Object.assign({}, state, {
      isAdminBasic: true,
    })
  ),
  [LOGIN_GIVE_ADMIN_COMMUNITY_ACCESS]: state => (
    Object.assign({}, state, {
      isAdminCommunity: true,
    })
  ),
  [LOGIN_GIVE_ADMIN_ACCESS]: state => (
    Object.assign({}, state, {
      isAdmin: true,
    })
  ),
  [APP_GIVE_CREDIT_CHECK_ACCESS]: state => (
    Object.assign({}, state, {
      creditCheckAccess: true,
    })
  ),

  [LOGIN_GIVE_EDIT_UNIT_PRICE_ACCESS]: state => (
    Object.assign({}, state, {
      allowEditUnitPrice: true,
    })
  ),
  [LOGIN_GIVE_EDIT_UNIT_DETAIL_ACCESS]: state => (
    Object.assign({}, state, {
      allowEditUnitDetails: true,
    })
  ),
  [LOGIN_FROM_ADFS]: (state, payload) => (
    Object.assign({}, state, {
      isADFS: !!payload.provider,
      adfsProvider: payload.provider,
    })
  ),
  companyCurrency: (state, payload) => {
    const oriState = state;
    if (payload.data) oriState.company.companyCurrency = payload.data;
    return oriState;
  },
});



// WEBPACK FOOTER //
// ./src/reducers/auth.js